import { Button, ClickEvent, Layout, SlideoutDecorator, TableRow, TableRowDisplayEvent, Label, Table } from "@mcleod/components";
import { AutogenLayoutOrderMultiSelectErrorSlideout } from "./autogen/AutogenLayoutOrderMultiSelectErrorSlideout";
import { OrderTabView } from "@mcleod/dispatch";
import { ModelRow } from "@mcleod/core";

const layoutPath = "lme/general/OrderMultiSelectErrorSlideout"

export class OrderMultiSelectErrorSlideout extends AutogenLayoutOrderMultiSelectErrorSlideout {
    public static async showSlideout(failedRows: TableRow[], errorRows: ModelRow[], slideoutButtonText: string, slideoutButtonAction: (selectedRows: TableRow[]) => any, isOpsMgmt: boolean) {
        const layout = Layout.getLayout(layoutPath) as OrderMultiSelectErrorSlideout;
        const actionButton = new Button({
            id: "buttonCompleteAction",
            caption: slideoutButtonText,
            onClick: (event: ClickEvent) => {
                layout.slideOut();
                slideoutButtonAction(layout.tableFailed.selectedRows);
            },
            backgroundColor: "primary",
            color: "primary.reverse",
            minWidth: 128,
            borderWidth: 0,
            rowBreak: false,
            enabled: false
        })

        layout.addLayoutDataLoadListener(() => {
            layout.tableFailed.addSelectionListener(() => {
                actionButton.enabled = layout.tableFailed.selectedRows.length > 0;
            });
        });

        const hasFailures = failedRows.length > 0;
        const hasErrors = errorRows.length > 0;

        return new SlideoutDecorator({
            title: "Update Error Details",
            layout: layout,
            width: "65%",
            fillVerticalSpace: true,
            doAfterSlideIn: async (decorator: SlideoutDecorator) => {
                layout.panelFailed.visible = hasFailures;

                const removeColumns = (table: Table, ...columns: string[]) => {
                    for (const column of columns) {
                        table.removeColumn(column);
                    }
                }
                if (hasFailures) {
                    layout.tableFailed.displayData(null, failedRows.map(row => row.data), 0);
                    layout.labelFailedCount.text = failedRows.length.toString();

                    if (isOpsMgmt)
                        removeColumns(layout.tableFailed, "Carrier", "Total");
                    else
                        removeColumns(layout.tableFailed, "Driver", "Tractor");
                }

                layout.panelErrors.visible = hasErrors;
                if (hasErrors) {
                    layout.tableErrors.displayData(null, errorRows, 0);
                    layout.labelErrorCount.text = errorRows.length.toString();

                    if (isOpsMgmt)
                        removeColumns(layout.tableErrors, "Carrier", "Total");
                    else
                        removeColumns(layout.tableErrors, "Driver", "Tractor");

                    if (hasFailures) {
                        layout.panelErrors.paddingTop = 20;
                    }
                }
            },
            onClose: async (cancelled: boolean) => {
                layout.slideOut();
            },
            addlComponents: hasFailures ? [actionButton] : []
        });
    }

    tableFailedOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const orderLabel = tableRow.findComponentById("labelFailedOrder") as Label;
        orderLabel.applyLinkStyle();
    }

    tableErrorsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const orderLabel = tableRow.findComponentById("labelErrorOrder") as Label;
        orderLabel.applyLinkStyle();
    }

    /** This is an event handler for the onClick event of labelOrder. */
    labelOrderOnClick(event: ClickEvent) {
        const label = event.target as Label;
        OrderTabView.navigateTo({ key: label.text, newTab: true });
    }
}
